module.exports = __webpack_public_path__ + "static/media/fracas.9cb9cbdc.png";